import { useState } from 'react';

/** Open, share (the phone's own sheet when it has one) and copy — the three things done with a link. */
export default function ShareBar({ url, title }: { url: string; title: string }) {
  const [copied, setCopied] = useState(false);
  const canShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      window.prompt('Copy this link', url);
    }
  }

  return (
    <div className="studio-share">
      <a className="btn pressable btn-primary clay-primary studio-share-main" href={url} target="_blank" rel="noreferrer">
        <span className="btn-label">Open it</span>
      </a>
      <div className="studio-share-row">
        {canShare && (
          <button
            type="button"
            className="studio-share-btn pressable"
            onClick={() => void navigator.share({ title, url }).catch(() => undefined)}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 3v12M7 8l5-5 5 5M5 14v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5" /></svg>
            Share
          </button>
        )}
        <button type="button" className="studio-share-btn pressable" onClick={() => void copy()} aria-live="polite">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="9" y="9" width="12" height="12" rx="2" /><path d="M5 15V5a2 2 0 0 1 2-2h10" /></svg>
          {copied ? 'Copied' : 'Copy link'}
        </button>
      </div>
      <p className="studio-url">{url.replace('https://', '')}</p>
    </div>
  );
}
